// extracted by mini-css-extract-plugin
export var orderSummary = "_s0-0";
export var showMoreLessButton = "_s0-1";